import { inject, Injectable } from '@angular/core';
import { AbcCore } from '@barthauer/abc/core';
import { AbcConfigService } from '@barthauer/abc/core/configuration';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  private coreService = inject(AbcCore);
  private configService = inject(AbcConfigService);

  constructor() {}

  queryLongitudinalSectionGraphics(
    pipeIds: string[],
    pipeObjectTypes: string[],
    pipeIsInFlowDirections: boolean[],
    settings: any,
    isInitial: boolean,
  ): Observable<ArrayBuffer> {
    const parameters: any = {};
    parameters.pipeIds = pipeIds;
    parameters.pipeObjectTypes = pipeObjectTypes;
    parameters.pipeIsInFlowDirections = pipeIsInFlowDirections;
    parameters.settings = settings;
    parameters.isInitial = isInitial;

    return this.executeWebApiPOSTMethod('api/Extensions/CmLongitudinalSection', parameters);
  }

  queryLongitudinalSectionReport(
    pipeIds: string[],
    pipeObjectTypes: string[],
    pipeIsInFlowDirections: boolean[],
    settings: any,
  ): Observable<Blob> {
    const parameters: any = {};
    parameters.pipeIds = pipeIds;
    parameters.pipeObjectTypes = pipeObjectTypes;
    parameters.pipeIsInFlowDirections = pipeIsInFlowDirections;
    parameters.settings = settings;

    return this.executeWebApiPOSTMethodBlob('api/Extensions/CmLongitudinalSection/Report', parameters);
  }

  persistLongitudinalSectionSettings(
    anyPipeId: string,
    anyPipeObjectType: string,
    anyPipeIsInFlowDirection: boolean,
    settings: any,
  ): Observable<ArrayBuffer> {
    const parameters: any = {};
    parameters.pipeIds = [anyPipeId];
    parameters.pipeObjectTypes = [anyPipeObjectType];
    parameters.pipeIsInFlowDirections = [anyPipeIsInFlowDirection];
    parameters.settings = settings;

    return this.executeWebApiPOSTMethod('api/Extensions/CmLongitudinalSection/Settings', parameters);
  }

  private executeWebApiPOSTMethod(url: string, body: any): Observable<ArrayBuffer> {
    return this.coreService.data.executeWebApiPOSTMethod(
      this.concat(this.configService.configuration.WebApi.BaseURL, url),
      body,
      true,
    );
  }

  private executeWebApiPOSTMethodBlob(url: string, body: any): Observable<Blob> {
    return this.coreService.data.executeWebApiPOSTMethodBlob(
      this.concat(this.configService.configuration.WebApi.BaseURL, url),
      body,
      true,
    );
  }

  private concat(str1: string, str2: string): string {
    if (str1[str1.length - 1] === '/') {
      return str1 + str2;
    } else {
      return str1 + '/' + str2;
    }
  }
}
